import {Modal} from "bootstrap";

export const ssoCheck  = () => {
    const signInButtons = document.querySelectorAll('#sso-login-check');

    if (signInButtons.length > 0) {
        signInButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                const popup = window.open(
                    "https://www.porncz.com/en/sign/in/check",
                    "ssoRelay",
                    "popup,width=100,height=100"
                );

                window.addEventListener("message", function handler(event) {
                    console.log(event);
                    if (event.data?.type === 'sso:token') {
                        window.removeEventListener("message", handler);
                        const token = event.data.token;
                        popup?.close();
                        if (token) {
                            const url = new URL(window.location.href);
                            url.searchParams.set('access_token', token);
                            window.location.href = url.toString();
                        } else {
                            const element = document.getElementById('sso-login-check');
                            console.log(element);
                            console.log(element.dataset);
                            if (element.dataset.openmodal) {
                                const modal = new Modal(element.dataset.openmodal);
                                modal.show();
                            }
                        }
                    }
                });

            });
        });
    }
}